import { render } from "./PendingTileGame.vue?vue&type=template&id=5ba7e809"
import script from "./PendingTileGame.vue?vue&type=script&lang=js"
export * from "./PendingTileGame.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__